import React, { useState, useEffect } from 'react';
import './style.scss';
import Container from './../../components/Container';
import { mensagemErro, mensagemSucesso } from './../../components/Layout';
import { useLayout } from './../../context/Layout';
import api from './../../api';

function Assinatura() {
    const { setLoadFull } = useLayout();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null); // 'active', 'inactive', 'loading'

    useEffect(() => {
        checkSubscriptionStatus();
    }, []);

    const checkSubscriptionStatus = async () => {
        const response = await api.get('/subscription/status');
        setStatus(response.data.status);
    };

    const handleSubscribe = async () => {
        setLoading(true);
        setLoadFull(true);

        try {
            const { data } = await api.post('/subscription/create-checkout-session');

            if (data.url) {
                window.location.href = data.url;
            } else {
                mensagemErro('Erro ao iniciar sessão de pagamento.');
            }

        } catch (error) {
            console.error(error);
            mensagemErro('Ocorreu um erro ao processar sua solicitação.');
        } finally {
            setLoading(false);
            setLoadFull(false);
        }
    };

    const handleManageSubscription = async () => {
        setLoading(true);
        setLoadFull(true);
        try {
            const { data } = await api.post('/subscription/portal-session');
            if (data.url) {
                window.location.href = data.url;
            } else {
                mensagemErro('Erro ao redirecionar para o portal.');
            }
        } catch (error) {
            console.error(error);
            mensagemErro('Erro ao acessar o portal de assinatura.');
        } finally {
            setLoading(false);
            setLoadFull(false);
        }
    }

    return (
        <Container title="Assinatura" titlesub="Gerencie seu plano">
            <div className="assinatura-page">
                <div className="header-section">
                    <h2>Escolha o plano ideal para você</h2>
                    <p>Tenha acesso completo a todas as funcionalidades do Ambientar</p>
                </div>

                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-4">
                        <div className="plan-card">
                            <h3 className="plan-title">Plano Pro</h3>
                            <div className="plan-price">
                                R$ 99,00 <span>/mês</span>
                            </div>
                            <ul className="plan-features list-unstyled">
                                <li><i className="ti-check"></i> Acesso ilimitado a licenças</li>
                                <li><i className="ti-check"></i> Monitoramento de condicionantes</li>
                                <li><i className="ti-check"></i> Relatórios inteligentes</li>
                                <li><i className="ti-check"></i> Suporte prioritário</li>
                            </ul>

                            {status === 'active' ? (
                                <button
                                    className="btn-subscribe"
                                    onClick={handleManageSubscription}
                                    disabled={loading}
                                >
                                    {loading ? 'Carregando...' : 'Gerenciar Assinatura'}
                                </button>
                            ) : (
                                <button
                                    className="btn-subscribe"
                                    onClick={handleSubscribe}
                                    disabled={loading}
                                >
                                    {loading ? 'Carregando...' : 'Assinar Agora'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
}

export default Assinatura;
